import { render } from "./DefaultPayrunModalMedia.vue?vue&type=template&id=0619315a"
import script from "./DefaultPayrunModalMedia.vue?vue&type=script&lang=js"
export * from "./DefaultPayrunModalMedia.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__